<script>
    let uistate = 'initial';
    let box;
    let box2;
    let box3;
    let box4;
    let box5;
    let box6;
    let box7;
</script>

<section
    id="slider-box"
    class={uistate}
    on:mouseenter={() => {
        uistate = 'initial';
        box.style.zIndex = '5';
        box2.style.zIndex = '5';
        box3.style.zIndex = '5';
        box4.style.zIndex = '5';
        box5.style.zIndex = '5';
        box6.style.zIndex = '5';
        box7.style.zIndex = '5';
    }}
    on:mouseleave={() => {
        uistate = 'slider';
    }}
>
    <div class="box-wrraper">
        <div class="box" id="box-1" bind:this={box}>
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/nVision.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-2" bind:this={box2}>
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/yesTheory.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-3" bind:this={box3}>
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/archform.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-4" bind:this={box4}>
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/juice.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-5" bind:this={box5}>
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/conquer.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-6" bind:this={box6}>
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/fxdxExchange.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-7" bind:this={box7}>
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/galy.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
    </div>
    <div class="box-wrraper2">
        <div class="box" id="box-8">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/newsyStock.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-9">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/sensorwake.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-10">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/inEvent.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-11">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/lumiereVR.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-12">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/basicBlock.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-13">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/zahara.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-14">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/harmony.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
    </div>
    <div class="box-wrraper3">
        <div class="box" id="box-15">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/ollang.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-16">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/helium.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-17">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/slideSpiel.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-18">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/dropWater.svg"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-19">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/bodegaBrands.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-20">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/leverage_Logo.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
        <div class="box" id="box-21">
            <img
                src="/images/duSuccessfulAlumniCompanyLogos/cosmicChamps.png"
                alt=""
                width="100%"
                height="auto"
            />
        </div>
    </div>
</section>

<style>
    #slider-box {
        width: 97vw;
        height: 38vw;
        margin-top: 2.876vw;
        padding: 2vw;
        position: relative;
    }
    .initial {
        position: absolute;
    }
    .slider {
        position: absolute;
    }
    .box-wrraper,
    .box-wrraper2,
    .box-wrraper3 {
        display: flex;
        overflow: hidden;
        justify-content: space-between;
    }
    .box {
        width: 10.292vw;
        height: 9.296vw;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 0.3vw;
        padding: 1vw;
        transition: all 0.5s;
    }
    .initial #box-1 {
        position: absolute;
        left: 5.91vw;
        top: 2vw;
        z-index: 10;
    }
    .initial #box-2 {
        position: absolute;
        left: 18.858vw;
        top: 2vw;
    }
    .initial #box-3 {
        position: absolute;
        left: 31.806vw;
        top: 2vw;
    }
    #box-3 img {
        margin-top: 3vw;
    }
    .initial #box-4 {
        position: absolute;
        left: 44.754vw;
        top: 2vw;
    }
    #box-4 img {
        margin-top: 1.5vw;
    }
    .initial #box-5 {
        position: absolute;
        left: 57.703vw;
        top: 2vw;
    }
    #box-5 img {
        margin-top: 2.3vw;
    }
    .initial #box-6 {
        position: absolute;
        left: 70.651vw;
        top: 2vw;
    }
    #box-6 img {
        margin-top: 1vw;
    }
    .initial #box-7 {
        position: absolute;
        left: 83.599vw;
        top: 2vw;
    }
    #box-7 img {
        height: 97%;
    }
    .initial #box-8 {
        position: absolute;
        left: 5.91vw;
        top: 14.5vw;
    }
    #box-8 img {
        height: 97%;
    }
    .initial #box-9 {
        position: absolute;
        left: 18.858vw;
        top: 14.5vw;
    }
    #box-9 img {
        margin-top: 1.8vw;
    }
    .initial #box-10 {
        position: absolute;
        left: 31.806vw;
        top: 14.5vw;
    }
    #box-10 img {
        margin-top: 2vw;
    }
    .initial #box-11 {
        position: absolute;
        left: 44.754vw;
        top: 14.5vw;
    }
    #box-11 img {
        margin-top: 2.5vw;
    }
    .initial #box-12 {
        position: absolute;
        left: 57.703vw;
        top: 14.5vw;
    }
    #box-12 img {
        margin-top: -0.5vw;
    }
    .initial #box-13 {
        position: absolute;
        left: 70.651vw;
        top: 14.5vw;
    }
    #box-13 img {
        height: 97%;
    }
    .initial #box-14 {
        position: absolute;
        left: 83.599vw;
        top: 14.5vw;
    }
    #box-14 img {
        margin-top: 2.5vw;
    }
    .initial #box-15 {
        position: absolute;
        left: 5.91vw;
        top: 27vw;
    }
    #box-15 img {
        margin-top: 1.2vw;
    }
    .initial #box-16 {
        position: absolute;
        left: 18.858vw;
        top: 27vw;
    }

    #box-16 img {
        margin-top: 2.5vw;
    }
    .initial #box-17 {
        position: absolute;
        left: 31.806vw;
        top: 27vw;
    }
    #box-17 img {
        margin-top: 2.5vw;
    }
    .initial #box-18 {
        position: absolute;
        left: 44.754vw;
        top: 27vw;
    }
    #box-18 img {
        margin-top: 2.5vw;
    }
    .initial #box-19 {
        position: absolute;
        left: 57.703vw;
        top: 27vw;
    }
    #box-19 img {
        margin-top: 2vw;
    }
    .initial #box-20 {
        position: absolute;
        left: 70.651vw;
        top: 27vw;
    }
    #box-20 img {
        margin-top: 2vw;
    }
    .initial #box-21 {
        position: absolute;
        left: 83.599vw;
        top: 27vw;
    }
    #box-21 img {
        margin-top: -0.6vw;
    }

    .slider #box-1,
    #box-8 {
        top: 3.453vw;
        left: 5.91vw;
        position: absolute;
    }
    .slider #box-2,
    #box-9,
    #box-15,
    #box-16 {
        left: 21.799vw;
        top: 12.616vw;
        position: absolute;
    }
    .slider #box-3,
    #box-10 {
        position: absolute;
        top: 0vw;
        left: 18.612vw;
    }
    .slider #box-4,
    #box-12,
    #box-17 {
        position: absolute;
        left: 35.412vw;
        top: 3.453vw;
    }
    .slider #box-5,
    #box-11,
    #box-18,
    #box-19 {
        position: absolute;
        left: 52.644vw;
        top: 7.503vw;
    }
    .slider #box-7,
    #box-14 {
        position: absolute;
        left: 72.444vw;
        top: 0.066vw;
    }
    .slider #box-21,
    #box-6 {
        position: absolute;
        left: 86.056vw;
        top: 5.406vw;
    }
    .slider #box-20,
    #box-13 {
        position: absolute;
        left: 69.256vw;
        top: 12.683vw;
    }
</style>
